import { ObservableArray, View } from "binder"
import { FeeBasePiceManipulationViewModel, SingleProductPrice } from "./feeBasePiceManipulation-viewModel"
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { CurrencySelector } from "src/erp/financial/currencyManipulation/currencySelector";
import { ServerSideDataLoader } from "uicomponents";

export class FeeBasePiceManipulationView extends View<FeeBasePiceManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-82575C1D-AFE0-45BB-9D5A-1404894D27B3"
    }
    loadHtml(): string {
        let element = require('./feeBasePiceManipulation.html').default;
        let style = require('./feeBasePiceManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader;} private _dataLoader: ServerSideDataLoader;
    public set items(v: ObservableArray<SingleProductPrice>) { this._items = v; } public get items(): ObservableArray<SingleProductPrice> { return this._items;} private _items: ObservableArray<SingleProductPrice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector;} private _districtSelector: DistrictSelector;
    public set currencySelector(v: CurrencySelector) { this._currencySelector = v; } public get currencySelector(): CurrencySelector { return this._currencySelector;} private _currencySelector: CurrencySelector;
    public set canUploadExcelFile(v: boolean) { this._canUploadExcelFile = v; } public get canUploadExcelFile(): boolean { return this._canUploadExcelFile; } private _canUploadExcelFile: boolean;
    
    downloadExcelTemplate(){
        this.dataContext.downloadExcelTemplate();
    }

    uploadExcelFile(){
        this.dataContext.uploadExcelFile();
    }
}
